import {
  SnippetElement,
  defineElement,
  liquidValue,
  onClick
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-CFQW6ARL.js";

// src/snippets/pb-shop-reviews-io-stars/pb-shop-reviews-io-stars.ts
var PbShopReviewsIoStars = class extends SnippetElement {
  scrollToReviews() {
    if (this.reviewsAnchor) {
      var reviewsContainer = document.querySelectorAll(this.reviewsAnchor)[0];
      reviewsContainer.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
    }
  }
};
__decorateClass([
  liquidValue("block.settings.reviews_anchor")
], PbShopReviewsIoStars.prototype, "reviewsAnchor", 2);
__decorateClass([
  onClick("[data-review-stars-container]")
], PbShopReviewsIoStars.prototype, "scrollToReviews", 1);
PbShopReviewsIoStars = __decorateClass([
  defineElement("pb-shop-reviews-io-stars")
], PbShopReviewsIoStars);
export {
  PbShopReviewsIoStars
};
